import React from 'react';
import Pagination from 'rc-pagination';

export const GridPager = ({...props}) => {	
	return(
            <Pagination {...props} />
		);
};

//export default GridPager;

// parameter			description							type							default
// defaultCurrent		uncontrolled current page			Number							1
// current				current page						Number							undefined
// total				items total count					Number							0
// defaultPageSize		default items per page				Number							10
// pageSize				items per page						Number							10
// onChange				page change callback				Function(current, pageSize)		-
// showSizeChanger		show pageSize changer				Bool							false
// pageSizeOptions		specify the sizeChanger selections	Array							['10', '20', '30', '40']
// onShowSizeChange		pageSize change callback			Function(current page, size)	-
// showQuickJumper		show quick goto jumper				Bool							false
// showTotal			show total records and range		Function(total, [from, to])		-
// className			className of pagination				String							-
// simple				when set, show simple pager			Object							null
// locale				to set l10n config					Object							zh_CN
// style				the style of pagination				Object							{}
// showLessItems		show less page items				Bool							false
// showTitle			show page items title				Bool							true
